import {get} from "axios";

export const getLocalizations = () => {
    return get(themosis.ajaxurl, {
        params: {
            action: "get_localizations",
        }
    })
};

export const getPublicTransport = () => {
    return get(themosis.ajaxurl, {
        params: {
            action: "get_public_transport",
        }
    })
}
